import { defineMessages } from 'react-intl';

import { emptyArray } from 'ui-components/default-props/empty';

import { purchaseOrderStatuses, purchaseOrderStatusNumbers } from '../data/purchase-order-statuses';

import type { IntlShape } from 'react-intl';

type CriteriaArgument = {
  id: string;
  value: string | number;
  displayName: string;
};

type Warehouse = {
  inventoryWarehouseId: number;
  name: string;
};

type Supplier = {
  label: string;
  value: string;
};

export const messages = defineMessages({
  warehouseFallback: {
    defaultMessage: 'Warehouse {warehouseId}',
    id: 'F3tIZo',
    description: 'Fallback display name for warehouse when name is not available',
  },
});

export const STATUS_CRITERIA_ARGUMENTS = (Object.keys(purchaseOrderStatusNumbers) as Array<keyof typeof purchaseOrderStatusNumbers>).map(
  (statusKey) => ({
    id: `option-status-${statusKey}`,
    value: purchaseOrderStatusNumbers[statusKey],
    displayName: purchaseOrderStatuses[statusKey],
  }),
);

export const createWarehouseCriteriaArguments = (warehouses: Warehouse[], intl: IntlShape): CriteriaArgument[] => {
  return warehouses.map((warehouse) => ({
    id: `option-warehouse-${warehouse.inventoryWarehouseId}`,
    value: warehouse.inventoryWarehouseId.toString(),
    displayName: warehouse.name || intl.formatMessage(messages.warehouseFallback, { warehouseId: warehouse.inventoryWarehouseId }),
  }));
};

export const WAREHOUSE_CRITERIA_ARGUMENTS = emptyArray;

export const createSupplierCriteriaArguments = (suppliers: Supplier[]): CriteriaArgument[] => {
  return suppliers.map((supplier) => ({
    id: `option-supplier-${supplier.value}`,
    value: supplier.value,
    displayName: supplier.label,
  }));
};

export const SUPPLIER_CRITERIA_ARGUMENTS = emptyArray;
